import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { to: '/', label: '首页' },
      { to: '/category/lianai', label: '恋爱漫画' },
      { to: '/category/xuanyi', label: '悬疑漫画' },
      { to: '/category/qihuan', label: '奇幻漫画' },
      { to: '/category/dongzuo', label: '动作漫画' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
      { to: '/about', label: '用户口碑' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { to: '#', label: '微博' },
      { to: '#', label: '微信公众号' },
      { to: '#', label: '小红书' },
      { to: '#', label: 'B站' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-foreground-50">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-accent-400"></i>
              </div>
              <span className="text-xl font-bold font-heading">汗汗漫画</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汗汗漫画——免费韩国漫画在线阅读平台。汇集海量韩漫资源，涵盖各类热门题材，为您提供优质的漫画阅读体验。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-200 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-primary-700/50">
          <div className="text-7xl md:text-9xl font-black font-heading text-primary-800/30 tracking-tighter select-none">
            汗汗漫画
          </div>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 汗汗漫画 HanHanManga. 本站所有漫画均来自互联网，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a href="#" className="hover:text-accent-400 transition-colors duration-200">隐私政策</a>
              <a href="#" className="hover:text-accent-400 transition-colors duration-200">服务条款</a>
              <a href="#" className="hover:text-accent-400 transition-colors duration-200">DMCA</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}